import * as LocationActions from './actions/location.actions';

export {LocationActions};
